import { TriangleAlert } from "lucide-react";
import { Box, Paper, Stack, Typography, useTheme } from "@mui/material";
import { palette } from "@powerdiary/components-library/lib";
import { useEffect } from "react";

export default function LinkUnavailable() {
    const theme = useTheme();

    useEffect(() => {
        document.title = "Link Unavailable - Client Bookings Zanda";
    }, []);

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            p={2}
            data-test-id="section_link_unavailable"
        >
            <Paper elevation={4}>
                <Stack spacing={3} p={4} alignItems="center">
                    <TriangleAlert
                        size={28}
                        strokeWidth={2}
                        color={theme.palette.primary.main}
                        data-test-id="icon_link_unavailable"
                        aria-hidden
                    />
                    <Box display="flex" flexDirection="column" gap={1}>
                        <Typography variant="heading3" textAlign="center" data-test-id="text_link_unavailable_title">
                            Whoops! This page doesn&apos;t seem to exist
                        </Typography>
                        <Typography
                            variant="paragraphMediumRegular"
                            textAlign="center"
                            data-test-id="text_link_unavailable_subtitle"
                        >
                            You might be using an invalid link.
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            background: palette.neutral[50],
                            borderRadius: 1,
                            padding: 2,
                        }}
                        data-test-id="section_link_unavailable_instructions"
                    >
                        <Typography variant="paragraphMediumBold" data-test-id="text_instructions_title">
                            What can you do?
                        </Typography>
                        <ul style={{ margin: 0 }}>
                            <li>
                                <Typography variant="paragraphMediumRegular" data-test-id="text_instruction_check_link">
                                    Double-check that the link hasn&apos;t expired or been used already.
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="paragraphMediumRegular" data-test-id="text_instruction_portal">
                                    Return to your client portal to book an appointment or view your invoices.
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="paragraphMediumRegular" data-test-id="text_instruction_contact">
                                    If you&apos;re still having trouble, contact your practice directly for help.
                                </Typography>
                            </li>
                        </ul>
                    </Box>
                </Stack>
            </Paper>
        </Box>
    );
}
